import '../styles/NavbarMobile.scss';
import { Link } from 'react-scroll';

export default function NavbarMobile() {
  return (
    <nav className='navbar-mobile' id='navbar'>
      <div className='nav-content'>
        <ul className='nav-items'>
          <li className='nav-item'>
            <Link
              activeClass='active'
              to='about'
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
            >
              ABOUT
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              activeClass='active'
              to='projects'
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
            >
              PROJECTS
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              activeClass='active'
              to='experience'
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
            >
              EXPERIENCE
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              activeClass='active'
              to='contact'
              spy={true}
              smooth={true}
              offset={-60}
              duration={500}
            >
              CONTACT
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
